module.exports = __webpack_public_path__ + "static/media/m8tj93.43cd9294.png";